import { useState } from 'react';
import { add, sub } from 'date-fns';

export interface MonthAndYear {
  month: number;
  year: number;
}

export function dateToMonthAndYear(date: Date): MonthAndYear {
  return { month: date.getMonth(), year: date.getFullYear() };
}

export interface UseCalendarSectionOptions {
  monthAndYear: MonthAndYear;
  onChangeMonthAndYear: (monthAndYear: MonthAndYear) => void;
}

export function useCalendarSection({
  monthAndYear,
  onChangeMonthAndYear
}: UseCalendarSectionOptions) {
  const referenceDate = new Date(monthAndYear.year, monthAndYear.month);
  const prevMonthReference = sub(referenceDate, { months: 1 });
  const nextMonthReference = add(referenceDate, { months: 1 });

  const goToPreviousMonth = () => onChangeMonthAndYear(dateToMonthAndYear(prevMonthReference));
  const goToNextMonth = () => onChangeMonthAndYear(dateToMonthAndYear(nextMonthReference));

  const [showSalesToCollect, setShowSalesToCollect] = useState(true);
  const toggleShowSalesToCollect = () => setShowSalesToCollect((v) => !v);
  const [showConfirmedSales, setShowConfirmedSales] = useState(true);
  const toggleShowConfirmedSales = () => setShowConfirmedSales((v) => !v);

  return {
    referenceDate,
    goToPreviousMonth,
    goToNextMonth,
    showSalesToCollect,
    showConfirmedSales,
    toggleShowSalesToCollect,
    toggleShowConfirmedSales
  };
}
